import request from '@/utils/request'

const baseUrlSimpleClassZhihuishu = 'https://simple-class.zhihuishu.com/simple-class'

// 直播列表的日期列表：
const getLiveDates = (params) => {
  return request({
    url: `/admin/live/dates/v100`,
    method: 'get',
    params,
  })
}

// 获取未读的站内信：
const getUnReadMessage = () => {
  return request({
    url: `/admin/message/unReadMessage/v100`,
    method: 'get',
  })
}

// 获取直播详情：
const getLiveDetail = (params) => {
  return request({
    url: `/admin/live/detail/v100`,
    method: 'get',
    params,
  })
}

// 获取直播详情接口2：
const getLiveDetailForAPP = (params) => {
  return request({
    baseURL: baseUrlSimpleClassZhihuishu,
    url: '/app/live/detail/v100',
    method: 'post',
    params
  })
}

// 获取客服电话：
const getStaffPhone = () => {
  return request({
    url: `/common/getStaffPhone/v100`,
    method: 'post',
  })
}

// 终止直播：
const stopLive = (params) => {
  return request({
    url: `/admin/live/stopLive/v100`,
    method: 'get',
    params,
  })
}

// 编辑直播名称：
const liveEdit = (params) => {
  return request({
    url: `/admin/live/editLive/v100`,
    method: 'post',
    data: params,
  })
}

/**
 * @description: 用户选中学校列表，用于下拉（主讲学校下拉列表）
 * @param {*}
 * @return {*}
 */
const getSelectSchoolList = () => {
  return request({
    url: `/admin/school/chechedSchool/v100`,
    method: 'get',
  })
}

/**
 * @description: 获取lc学校下主讲教室，用于下拉
 * @params {*} schoolCode 学校id
 * @return {*}
 */
const getSelectClassRoomList = (params) => {
  return request({
    url: `/admin/school/getZJClassroomBySchoolCode/v100`,
    method: 'get',
    params,
  })
}

/**
 * @description: 获取lc学校下教室导播信息，用于下拉
 * @param {*} classCodes 教室编码
 * @return {*}
 */
const getSelectTeacherList = (params) => {
  return request({
    url: `/admin/school/getRoomDaoboDetailByRoomCodes/v100`,
    method: 'get',
    params,
  })
}

/**
 * @description: 创建纯极简直播
 * @param {*}
 * @return {*}
 */
const createClassLive = (params) => {
  return request({
    url: `/admin/live/createLive/v100`,
    method: 'post',
    data: params,
  })
}

/**
 * @description: 获取lc学校下听课教室，用于下拉
 * @param {*} schoolCode 学校id
 * @return {*}
 */
const getListenClassRoomList = (params) => {
  return request({
    url: `/admin/school/getClassroomBySchoolCode/v100`,
    method: 'get',
    params,
  })
}

/**
 * @description: 获取lc学校下听课教室，用于下拉，加上了极简教室
 * @param {*} schoolCode 学校id
 * @return {*}
 */
 const getListenClassRoomListForAll = params => {
  return request({
    url: `/admin/school/getAllClassroomBySchoolCode/v100`,
    method: 'get',
    params
  })
}

/**
 * @description: 创建智慧教室
 * @param {*}
 * @return {*}
 */
const createLCClassLive = (params) => {
  return request({
    url: `/admin/live/createLcLive/v100`,
    method: 'post',
    data: params,
  })
}

/**
 * @description: 获取课程列表
 * @param {*}
 * @return {*}
 */
const getCourseList = (params) => {
  return request({
    url: `/admin/course/list/v100`,
    method: 'post',
    data: params,
  })
}

/**
 * @description: 删除课程
 * @param {*}
 * @return {*}
 */
const deleteCourse = (params) => {
  return request({
    url: `/admin/course/deleted/v100`,
    method: 'get',
    params,
  })
}

// 课程相关
/**
 * @description: 创建纯极简教室课程
 * @param {*}
 * @return {*}
 */
const createSimpleCourse = (params) => {
  return request({
    url: `/admin/course/createSimpleCourse/v100`,
    method: 'post',
    data: params,
  })
}

/**
 * @description: 创建智慧教室课程
 * @param {*}
 * @return {*}
 */
const createLcCourse = (params) => {
  return request({
    url: `/admin/course/createLcCourse/v100`,
    method: 'post',
    data: params,
  })
}

/**
 * @description: 课程详情
 * @param {*}
 * @return {*}
 */
const getCourseDetail = (params) => {
  return request({
    url: `/admin/course/detail/v100`,
    method: 'get',
    params,
  })
}

/**
 * @description: 修改课程名称
 * @param {*}
 * @return {*}
 */
const editCourseName = (params) => {
  return request({
    url: `/admin/course/edit/v100`,
    method: 'post',
    data: params,
  })
}

/**
 * @description: 获取课程下直播列表
 * @param {*}
 * @return {*}
 */
const getCourseLiveList = (params) => {
  return request({
    url: `/admin/course/liveList/v100`,
    method: 'get',
    params,
  })
}

/**
 * @description: 删除直播
 * @param {*}
 * @return {*}
 */
const delCourseLive = (params) => {
  return request({
    url: `/admin/live/deleted/v100`,
    method: 'get',
    params,
  })
}

/**
 * @description: 获取邀请码
 * @param {*}
 * @return {*}
 */
const getInvitationCode = (params) => {
  return request({
    url: `/admin/course/getInvitationCode/v100`,
    method: 'get',
    params,
  })
}

/**
 * @description:  获取学期列表
 * @param {*}
 * @return {*}
 */
const getTermInfo = (params) => {
  return request({
    url: `/admin/school/getTermInfo/v100`,
    method: 'get',
    params,
  })
}

/**
 * @description: 查询纯极简直播初始信息 （编辑纯极简直播需要）
 * @param {*}
 * @return {*}
 */
const getSimpleLiveInfo = (params) => {
  return request({
    url: `/admin/live/getSimpleLive/v100`,
    method: 'get',
    params,
  })
}

/**
 * @description: 编辑纯极简直播初始信息 （编辑纯极简直播需要）
 * @param {*}
 * @return {*}
 */
const editSimpleLive = (params) => {
  return request({
    url: `/admin/live/editSimpleLive/v100`,
    method: 'post',
    data: params,
  })
}

/**
 * @description: 查询智慧教室直播初始信息 （编辑智慧教室直播需要）
 * @param {*}
 * @return {*}
 */
const getLcLiveInfo = (params) => {
  return request({
    url: `/admin/live/getLcLiveInfo/v100`,
    method: 'get',
    params,
  })
}

/**
 * @description: 编辑智慧教室直播初始信息
 * @param {*}
 * @return {*}
 */
const editLcLiveInfo = (params) => {
  return request({
    url: `/admin/live/editLcLiveInfo/v100`,
    method: 'post',
    data: params,
  })
}

/**
 * @description: 单独添加收视教室 （编辑智慧教室直播需要,编辑的时候单独添加一间收视使用）
 * @param {*}
 * @return {*}
 */
const addWatchRoom = (params) => {
  return request({
    url: `/admin/live/addWatchRoom/v100`,
    method: 'post',
    data: params,
  })
}

/**
 * @description: 删除收视教室 （编辑智慧教室直播需要,编辑的时候单独删除一间收视使用）
 * @param {*}
 * @return {*}
 */
const removeWatchRoom = (params) => {
  return request({
    url: `/admin/live/removeWatchRoom/v100`,
    method: 'get',
    params,
  })
}

/**
 * @description: 校验直播教室是否被占用
 * @param {*}
 * @return {*}
 */
const checkLcClassInfo = (params) => {
  return request({
    url: `/admin/live/checkLcClassInfo/v100`,
    method: 'post',
    data: params,
  })
}

/**
 * @description: 根据学校id获取极简教室列表（极简做主讲的主讲教室）
 * @params {*} schoolCode 学校id
 * @return {*}
 */
const getSmallestClassRoomList = (params) => {
  return request({
    url: `/admin/school/getSimpleClassroomBySchoolCode/v100`,
    method: 'get',
    params,
  })
}

// 网易im初始化接口：
const initWebIm = (params) => {
  return request({
    baseURL: baseUrlSimpleClassZhihuishu,
    url: `/im/netease/init/v100`,
    method: 'post',
    params,
  })
}

// 告知后端需要通过im推送4001消息：
const informServe4001INeed = (params) => {
  return request({
    baseURL: baseUrlSimpleClassZhihuishu,
    url: `/im/netease/entrySuccess/v100`,
    method: 'post',
    params,
  })
}

/**
 * @description: 根据学校id获取所有教室列表（含极简）：极简做主讲的听课教室  极简听课教室
 * @params {*} schoolCode 学校id
 * @return {*}
 */
const getAllClassroomBySchoolCode = (params) => {
  return request({
    url: `/admin/school/getAllClassroomBySchoolCode/v100`,
    method: 'get',
    params,
  })
}

/**
 * @description: 添加教师
 * @param {*}
 * @return {*}
 */
const saveTeacherInfo = (params) => {
  return request({
    baseURL: baseUrlSimpleClassZhihuishu,
    url: `/admin/teacherManage/saveTeacherInfo`,
    method: 'post',
    data: params,
  })
}

/**
 * @description: 获取所有导播列表 极简做主讲的导播列表
 * @params {*}
 * @return {*}
 */
const getAllRoomDaoboDetail = (params) => {
  return request({
    url: `/admin/school/getAllRoomDaoboDetail/v100`,
    method: 'get',
    params,
  })
}

/**
 * @description: 创建课程直播接口后，web端需要轮询此接口获取创建直播结果
 * @param {*} params
 * @return {*}
 */
const getCreatedLiveResult = (params) => {
  return request({
    url: `/admin/course/getCreatedLiveResult/v100`,
    method: 'get',
    params,
  })
}

/**
 * @description: 获取设备厂商接口
 * @param {*} params
 * @return {*}
 */
const getManuFacturerInfo = params => {
  return request({
    // url: `/admin/device/getManuFacturerInfo`,
    url: `/admin/classroom/device/allManufacturer`,
    method: 'get',
    params
  })
}

/**
 * @description: 获取所有专员信息
 * @param {*} params
 * @return {*}
 */
const findAllCommissionerList = params => {
  return request({
    url: `/admin/school/findAllCommissionerList/v100`,
    method: 'get',
    params
  })
}

/**
 * @description: 获取声网拉流token（纯极简）
 * @param {any} params
 * @return {*}
 */
const agoraGetSubscribeTokenByLiveId = params => {
  return request({
    baseURL: baseUrlSimpleClassZhihuishu,
    url: '/agora/getSubscribeTokenByLiveId',
    method: 'get',
    params
  })
}

/**
 * @description: 获取声网拉流token（混合模式）
 * @param {any} params
 * @return {*}
 */
 const agoraGetSubscribToken = params => {
  return request({
    baseURL: baseUrlSimpleClassZhihuishu,
    url: '/agora/getSubscribToken',
    method: 'get',
    params
  })
}

/**
 * @description: 获取拼接好的rtsp地址
 * @param {*} params
 * @return {*}
 */
const getRtspPath = params => {
  return request({
    // url: '/admin/device/getRtspPath',
    url: '/admin/classroom/device/rtspPath',
    method: 'get',
    params
  })
}

/**
 * @description: 查询教室设备编号
 * @param {object} params
 * @return {*}
 */
const getCameraCode = (params) => {
  return request({
    baseURL: baseUrlSimpleClassZhihuishu,
    url: '/device/getCameraCode/v100',
    method: 'get',
    params
  })
}

/**
 * @description: 教室球机控制
 * @param {any} params
 * @return {*}
 */
 const liveDeviceControl = (params) => {
  return request({
    baseURL: baseUrlSimpleClassZhihuishu,
    url: '/app/live/deviceControl/v100',
    method: 'post',
    data: params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

/**
 * @description: 导出课程下直播
 * @param {*} params
 * @return {*}
 */
const exportCourseLiveList = (params) => {
  return request({
    url: `/admin/course/exportCourseLiveList/v100`,
    method: 'get',
    params,
    responseType: 'blob'
  })
}

/**
 * @description: 导出课程列表
 * @param {*} params
 * @return {*}
 */
const exportCourseList = (params) => {
  return request({
    url: '/admin/course/exportCourseList/v100',
    method: 'post',
    data: params,
    responseType: 'blob'
  })
}

/**
 * @description: 活动列表
 * @param {*} params
 * @return {*}
 */
const getActiveList = (params) => {
  return request({
    url: `/admin/activity/activityList/v100`,
    method: 'post',
    data: params,
  })
}

/**
 * @description: 创建活动
 * @param {*} params
 * @return {*}
 */
const createActivity = (params) => {
  return request({
    url: `/admin/activity/createActivity/v100`,
    method: 'post',
    data: params,
  })
}

/**
 * @description: 直播列表
 * @param {*} params
 * @return {*}
 */
const getLiveLive = (params) => {
  return request({
    url: `/admin/activity/liveLive/v100`,
    method: 'post',
    data: params,
  })
}

/**
 * @description: 删除活动
 * @param {*} params
 * @return {*}
 */
const deleteActivity = (params) => {
  return request({
    url: `/admin/activity/deleteActivity/v100`,
    method: 'get',
    params
  })
}

/**
 * @description: 活动详情
 * @param undefined
 * @return {*}
 */
const getActivityLive = (params) => {
  return request({
    url: `/admin/activity/getActivityLive/v100`,
    method: 'get',
    params
  })
}

/**
 * @description: 删除活动下直播
 * @param undefined
 * @return {*}
 */
const deleteActivityLive = (params) => {
  return request({
    url: `/admin/activity/deleteActivityLive/v100`,
    method: 'get',
    params
  })
}

/**
 * @description: 编辑活动下直播
 * @param undefined
 * @return {*}
 */
const updateActivityLive = (params) => {
  return request({
    url: `/admin/activity/updateActivityLive/v100`,
    method: 'get',
    params
  })
}

/**
 * @description: 更新活动名称
 * @param undefined
 * @return {*}
 */
const updateActivityInfo = (params) => {
  return request({
    url: `/admin/activity/updateActivityInfo/v100`,
    method: 'get',
    params
  })
}

/**
 * @description: 分页查询AI视频切片列表
 * @param undefined
 * @return {*}
 */
 const videoSliceList = (params) => {
  return request({
    url: `/ai-video/list`,
    method: 'get',
    params
  })
}

/**
 * @description: 根据id删除切片任务
 * @param undefined
 * @return {*}
 */
 const videoSliceDelete = (params) => {
  return request({
    url: `/ai-video/delete`,
    method: 'post',
    params
  })
}

/**
 * @description: 分页查询关联直播列表
 * @param undefined
 * @return {*}
 */
 const contactList = (params) => {
  return request({
    url: `/ai-video/live/list`,
    method: 'get',
    params
  })
}

/**
 * @description: 关联直播
 * @param undefined
 * @return {*}
 */
 const associateLive = (params) => {
  return request({
    url: `/ai-video/associateLive`,
    method: 'post',
    params
  })
}

/**
 * @description: 直播总数
 * @param undefined
 * @return {*}
 */
 const associateLiveIds = () => {
  return request({
    url: `/ai-video/associateLiveIds`,
    method: 'get'
  })
}

/**
 * @description: 融合失败 重新发起融合
 * @param undefined
 * @return {*}
 */
 const videoSliceMerge = (params) => {
  return request({
    url: `/ai-video/merge`,
    method: 'post',
    params
  })
}


/**
 * @description: 转码结果
 * @param undefined
 * @return {*}
 */
 const checkTranscode = (params) => {
  return request({
    url: `/ai-video/checkTranscode`,
    method: 'get',
    params
  })
}

/**
 * @description: 二维码绑定教室
 * @param undefined
 * @return {*}
 */
 const bindQr = (params) => {
  return request({
    url: `/admin/classroom/bindQr`,
    method: 'get',
    params
  })
}

/**
 * @description: 教室绑定设备搜索
 * @param undefined
 * @return {*}
 */
 const bindingList = (params) => {
  return request({
    url: `/admin/classroom/bindingList`,
    method: 'get',
    params
  })
 }
// 课程号查询翻转课课程信息
const getAidedTeachCourseInfo = (params) => {
  return request({
    url: `/admin/activity/getAidedTeachCourseInfo`,
    method: 'get',
    params
  })
}
// 新增翻转课
const createCourse = (params) => {
  return request({
    url: `/admin/activity/createCourse`,
    method: 'post',
    params
  })
}
// 编辑翻转课
const editCourse = (params) => {
  return request({
    url: `/admin/activity/editCourse`,
    method: 'post',
    params
  })
}
// 删除翻转课
const deleteActivityCourse = (params) => {
  return request({
    url: `/admin/activity/deleteActivityCourse`,
    method: 'post',
    params
  })
}
// 删除翻转课
const sortActivityCourse = (params) => {
  return request({
    url: `/admin/activity/sortActivityCourse`,
    method: 'get',
    params
  })
}

export default {
  updateActivityInfo,
  updateActivityLive,
  deleteActivityLive,
  getActivityLive,
  deleteActivity,
  getLiveLive,
  createActivity,
  getActiveList,
  exportCourseList,
  exportCourseLiveList,
  getRtspPath,
  findAllCommissionerList,
  getManuFacturerInfo,
  getSmallestClassRoomList,
  getAllRoomDaoboDetail,
  getAllClassroomBySchoolCode,
  getCreatedLiveResult,
  saveTeacherInfo,
  checkLcClassInfo,
  editLcLiveInfo,
  removeWatchRoom,
  addWatchRoom,
  getLcLiveInfo,
  editSimpleLive,
  getSimpleLiveInfo,
  getTermInfo,
  getInvitationCode,
  delCourseLive,
  getCourseLiveList,
  editCourseName,
  getCourseDetail,
  createLcCourse,
  createSimpleCourse,
  deleteCourse,
  getCourseList,
  createLCClassLive,
  getListenClassRoomList,
  getListenClassRoomListForAll,
  createClassLive,
  getSelectTeacherList,
  getSelectClassRoomList,
  getSelectSchoolList,
  getLiveDates,
  getUnReadMessage,
  getLiveDetail,
  getLiveDetailForAPP,
  getStaffPhone,
  stopLive,
  liveEdit,
  initWebIm,
  informServe4001INeed,
  agoraGetSubscribeTokenByLiveId,
  agoraGetSubscribToken,
  getCameraCode,
  liveDeviceControl,
  videoSliceList,
  videoSliceDelete,
  contactList,
  associateLive,
  associateLiveIds,
  videoSliceMerge,
  checkTranscode,
  bindQr,
  bindingList,

  getAidedTeachCourseInfo,
  createCourse,
  deleteActivityCourse,
  editCourse,
  sortActivityCourse
}
